var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    stroke: "#2C67F1",
    strokeWidth: 3,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1525_102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4167 26.6665V23.9998C23.4167 22.5853 22.8548 21.2288 21.8546 20.2286C20.8544 19.2284 19.4978 18.6665 18.0833 18.6665H7.41668C6.00219 18.6665 4.64563 19.2284 3.64544 20.2286C2.64525 21.2288 2.08334 22.5853 2.08334 23.9998V26.6665",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 13.3332C15.6955 13.3332 18.0833 10.9454 18.0833 7.99984C18.0833 5.05432 15.6955 2.6665 12.75 2.6665C9.80447 2.6665 7.41666 5.05432 7.41666 7.99984C7.41666 10.9454 9.80447 13.3332 12.75 13.3332Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4167 26.6665V23.9998C31.4158 22.8181 31.0225 21.6702 30.2985 20.7363C29.5745 19.8023 28.5608 19.1353 27.4167 18.8398",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0833 2.83984C23.2306 3.13358 24.2474 3.80078 24.9735 4.73626C25.6997 5.67174 26.0938 6.82228 26.0938 8.00651C26.0938 9.19074 25.6997 10.3413 24.9735 11.2768C24.2474 12.2122 23.2306 12.8794 22.0833 13.1732",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1525_102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvite);
export default __webpack_public_path__ + "static/media/invite.ee473bf8f580f41fcb170c27d26b4c7b.svg";
export { ForwardRef as ReactComponent };